/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One frame's server length (see FrameLength), with the overlay presigned.
 * @export
 * @interface ServerLengthFrameSchema
 */
export interface ServerLengthFrameSchema {
    /**
     * 
     */
    frameIndex: number;
    /**
     * 
     */
    segmentationConfidence: number | null;
    /**
     * 
     */
    midlineConfidence: number | null;
    /**
     * 
     */
    lengthMillimeters: number | null;
    /**
     * 
     */
    medianDepthLengthMillimeters: number | null;
    /**
     * 
     */
    medianDepthMeters: number | null;
    /**
     * 
     */
    overlayUrl: string | null;
    /**
     * 
     */
    maskUrl: string | null;
    /**
     * 
     */
    error: string | null;
}

/**
 * Check if a given object implements the ServerLengthFrameSchema interface.
 */
export function instanceOfServerLengthFrameSchema(value: object): value is ServerLengthFrameSchema {
    if ((!('frameIndex' in (value as Record<string, any>)) && !('frame_index' in (value as Record<string, any>))) || ((value as Record<string, any>)['frameIndex'] === undefined && (value as Record<string, any>)['frame_index'] === undefined)) return false;
    if ((!('segmentationConfidence' in (value as Record<string, any>)) && !('segmentation_confidence' in (value as Record<string, any>))) || ((value as Record<string, any>)['segmentationConfidence'] === undefined && (value as Record<string, any>)['segmentation_confidence'] === undefined)) return false;
    if ((!('midlineConfidence' in (value as Record<string, any>)) && !('midline_confidence' in (value as Record<string, any>))) || ((value as Record<string, any>)['midlineConfidence'] === undefined && (value as Record<string, any>)['midline_confidence'] === undefined)) return false;
    if ((!('lengthMillimeters' in (value as Record<string, any>)) && !('length_millimeters' in (value as Record<string, any>))) || ((value as Record<string, any>)['lengthMillimeters'] === undefined && (value as Record<string, any>)['length_millimeters'] === undefined)) return false;
    if ((!('medianDepthLengthMillimeters' in (value as Record<string, any>)) && !('median_depth_length_millimeters' in (value as Record<string, any>))) || ((value as Record<string, any>)['medianDepthLengthMillimeters'] === undefined && (value as Record<string, any>)['median_depth_length_millimeters'] === undefined)) return false;
    if ((!('medianDepthMeters' in (value as Record<string, any>)) && !('median_depth_meters' in (value as Record<string, any>))) || ((value as Record<string, any>)['medianDepthMeters'] === undefined && (value as Record<string, any>)['median_depth_meters'] === undefined)) return false;
    if ((!('overlayUrl' in (value as Record<string, any>)) && !('overlay_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['overlayUrl'] === undefined && (value as Record<string, any>)['overlay_url'] === undefined)) return false;
    if ((!('maskUrl' in (value as Record<string, any>)) && !('mask_url' in (value as Record<string, any>))) || ((value as Record<string, any>)['maskUrl'] === undefined && (value as Record<string, any>)['mask_url'] === undefined)) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ServerLengthFrameSchemaFromJSON(json: any): ServerLengthFrameSchema {
    return ServerLengthFrameSchemaFromJSONTyped(json, false);
}

export function ServerLengthFrameSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServerLengthFrameSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'frameIndex': json['frame_index'],
        'segmentationConfidence': json['segmentation_confidence'],
        'midlineConfidence': json['midline_confidence'],
        'lengthMillimeters': json['length_millimeters'],
        'medianDepthLengthMillimeters': json['median_depth_length_millimeters'],
        'medianDepthMeters': json['median_depth_meters'],
        'overlayUrl': json['overlay_url'],
        'maskUrl': json['mask_url'],
        'error': json['error'],
    };
}

export function ServerLengthFrameSchemaToJSON(json: any): ServerLengthFrameSchema {
    return ServerLengthFrameSchemaToJSONTyped(json, false);
}

export function ServerLengthFrameSchemaToJSONTyped(value?: ServerLengthFrameSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'frame_index': value['frameIndex'],
        'segmentation_confidence': value['segmentationConfidence'],
        'midline_confidence': value['midlineConfidence'],
        'length_millimeters': value['lengthMillimeters'],
        'median_depth_length_millimeters': value['medianDepthLengthMillimeters'],
        'median_depth_meters': value['medianDepthMeters'],
        'overlay_url': value['overlayUrl'],
        'mask_url': value['maskUrl'],
        'error': value['error'],
    };
}

